export { AtnDsPageComponent as Component } from './page.component'
export * as child from './components'
